export default __webpack_public_path__ + "static/media/img-slider-urban-fund-3.c62593f6.png";